import { Row } from "@tanstack/react-table";

import { Button } from "@/components/ui/button/button";

import { MyLead } from "./schema";
import { useTakeActionModal } from "../take-action-modal/use-action-modal";

interface DataTableRowActionsProps<TData> {
  row: Row<TData>;
}

export function DataTableRowActions<TData>({
  row,
}: DataTableRowActionsProps<TData>) {
  const originData = row.original as MyLead;

  const { onOpenChange, setLead } = useTakeActionModal();

  return (
    <>
      <Button
        variant="ghost"
        size="sm"
        className="flex data-[state=open]:bg-muted"
        onClick={() => {
          setLead({
            id: originData?.id,
          });
          onOpenChange(true);
        }}
      >
        Change Calling Status
      </Button>
    </>
  );
}
